import {QUESTION_TYPES} from './appConstants';

export const CREATE_FIELDS = {
  TITLE: 'TITLE',
  DESCRIPTION: 'DESCRIPTION',
  OPTION_TYPE: 'OPTION_TYPE',
  IMAGE: 'IMAGE',
  IMAGE_2: 'IMAGE_2',
  OPTIONS: 'OPTIONS',
  EXPLANATION: 'EXPLANATION',
  CATEGORY: 'CATEGORY',
  CONTENT_LANGUAGE_SELECTION: 'CONTENT_SELECTION',
  CROSSWORD_INPUT: 'CROSSWORD_INPUT',
  HASHTAGS: 'HASHTAGS',
  SCHEDULE: 'SCHEDULE',
  DIFFICULTY: 'DIFFICULTY',
  NUMBER_OF_ATTEMPTS_FIELD: 'NUMBER_OF_ATTEMPTS_FIELD',
  TIMERS: 'TIMERS',
  ALLOW_MANUAL_ENTER_OPTIONS: 'ALLOW_MANUAL_ENTER_OPTIONS',
  ALLOW_SELECTION_OF_MULTIPLE_OPTIONS: 'ALLOW_SELECTION_OF_MULTIPLE_OPTIONS',
  RANDOMIZE_OPTIONS: 'RANDOMIZE_OPTIONS',
  PRIVATE_QUESTION: 'PRIVATE_QUESTION',
  VOTES_VISIBILITY: 'VOTES_VISIBILITY',
  CHANGE_VOTES: 'CHANGE_VOTES',
  DISABLE_NOTOFICATION: 'DISABLE_NOTOFICATION',
  CLICK_TO_VOTE: 'CLICK_TO_VOTE',
  HIDE_OPTIONS_ON_LOAD: 'HIDE_OPTIONS_ON_LOAD',
  RESULTS_VISIBILITY_FIELD: 'RESULTS_VISIBILITY_FIELD',
  HINT: 'HINT',
  ATTEMPTS: 'ATTEMPTS',
  WORDSEARCH_INPUT: 'WORDSEARCH_INPUT',
  SPIN_WHEEL_INPUT: 'SPIN_WHEEL_INPUT',
  MIN_MAX: 'MIN_MAX',
  COUNTRY: 'COUNTRY',
  WORDLE_INPUT: 'WORDLE_INPUT',
  WORDLE_NUMBER_OF_WORDS: 'WORDLE_NUMBER_OF_WORDS',
  CROSS_MATH: 'CROSS_MATH',
  CROSS_MATH_GRID: 'CROSS_MATH_GRID',
  IMAGE_WORD_PUZZLE_INPUT: 'IMAGE_WORD_PUZZLE_INPUT'
}

const {
  TITLE,
  DESCRIPTION,
  OPTION_TYPE,
  IMAGE,
  CROSSWORD_INPUT,
  ALLOW_MANUAL_ENTER_OPTIONS,
  ALLOW_SELECTION_OF_MULTIPLE_OPTIONS,
  CATEGORY,
  CHANGE_VOTES,
  CLICK_TO_VOTE,
  CONTENT_LANGUAGE_SELECTION,
  DIFFICULTY,
  DISABLE_NOTOFICATION,
  EXPLANATION,
  HASHTAGS,
  HIDE_OPTIONS_ON_LOAD,
  IMAGE_2,
  OPTIONS,
  RANDOMIZE_OPTIONS,
  NUMBER_OF_ATTEMPTS_FIELD,
  PRIVATE_QUESTION,
  RESULTS_VISIBILITY_FIELD,
  SCHEDULE,
  VOTES_VISIBILITY,
  TIMERS,
  HINT,
  ATTEMPTS,
  WORDSEARCH_INPUT,
  SPIN_WHEEL_INPUT,
  MIN_MAX,
  COUNTRY,
  WORDLE_INPUT,
  WORDLE_NUMBER_OF_WORDS,
  CROSS_MATH,
  CROSS_MATH_GRID,
  IMAGE_WORD_PUZZLE_INPUT
} = CREATE_FIELDS;

export const COMMON_FIELDS = [TITLE, HASHTAGS, SCHEDULE];
export const CREATE_FIELDS_BY_Q_TYPE = {
  [QUESTION_TYPES.POLL]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, COUNTRY, CONTENT_LANGUAGE_SELECTION, OPTIONS, OPTION_TYPE],
  [QUESTION_TYPES.QUIZ]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, OPTION_TYPE, COUNTRY, CONTENT_LANGUAGE_SELECTION],
  [QUESTION_TYPES.WORD_SEARCH_PUZZLE]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, COUNTRY, WORDSEARCH_INPUT],
  [QUESTION_TYPES.CROSS_WORD_PUZZLE]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, COUNTRY, CROSSWORD_INPUT],
  [QUESTION_TYPES.JIGSAW_PUZZLE]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, HINT, COUNTRY, IMAGE_2, DIFFICULTY, ATTEMPTS],
  [QUESTION_TYPES.IMAGE_SWAP]: [...COMMON_FIELDS, DESCRIPTION, COUNTRY, IMAGE_2, DIFFICULTY],
  [QUESTION_TYPES.SPIN_A_WHEEL]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, IMAGE, COUNTRY, CONTENT_LANGUAGE_SELECTION, SPIN_WHEEL_INPUT],
  [QUESTION_TYPES.MARKS]: [...COMMON_FIELDS, DESCRIPTION, CATEGORY, CONTENT_LANGUAGE_SELECTION, IMAGE, COUNTRY, MIN_MAX],
  [QUESTION_TYPES.WORDLE]: [...COMMON_FIELDS, WORDLE_INPUT, WORDLE_NUMBER_OF_WORDS],
  [QUESTION_TYPES.MATH_SQUARE]: [...COMMON_FIELDS, CROSS_MATH_GRID, CROSS_MATH],
  [QUESTION_TYPES.BASIC_MATH]: [...COMMON_FIELDS, CROSS_MATH_GRID],
  [QUESTION_TYPES.IMAGE_WORD_PUZZLE]: [...COMMON_FIELDS, IMAGE_2, IMAGE_WORD_PUZZLE_INPUT],
}

